export default __webpack_public_path__ + "static/media/cart-gray.2f050b2a.svg";